<!-- privacy 隐私协议 -->
<template>
  <div class="privacy-box">
    <div class="modify-time">
      <p>更新日期：2021年11月4日</p>
      <p>生效日期：2021年11月4日</p>
    </div>
    <div class="content">
      <div class="content-text mrb24">
        中交智运有限公司（以下简称“中交智运”或“我们”）深知个人信息对您的重要性，我们将按照法律法规的规定，采用安全的保护措施，保护您的个人信息及隐私安全。因此，我们制定本“隐私政策”并特别提示：希望您在使用中交智运产品及相关服务前仔细阅读并理解本隐私政策，您可以按照指引做出您的适当选择。
      </div>
      <div class="content-text">
        <p>本隐私政策将帮助您了解以下内容：</p>
        <p>⼀、我们如何收集和使用您的个人信息</p>
        <p>二、我们如何存储个⼈信息</p>
        <p>三、我们如何共享、转让、公开披露个人信息</p>
        <p>四、您的权利</p>
        <p>五、我们如何处理儿童的个人信息</p>
        <p>六、您的个人信息如何在全球范围转移</p>
        <p>七、本隐私权政策如何更新</p>
        <p>八、如何联系我们</p>
      </div>
      <div class="primary-title">⼀、我们如何收集和使用您的个人信息</div>
      <div class="content-text">
        在您使用中交智运产品及服务的过程中，我们将根据合法、正当、必要的原则，收集信息。我们收集或请您提供的信息将用于：
        <p>1.保障产品的正常基础运行；</p>
        <p>2.实现各项功能和服务；</p>
        <p>3.优化、改善产品和服务；</p>
        <p>4.保障产品、服务以及用户使用安全；</p>
        <p>5.遵循法律法规与国家标准的规定。</p>
      </div>
      <div class="secondary-title">
        （一） 保障中交智运产品和相关服务的正常运行
      </div>
      <div class="content-text">
        当您使用中交智运产品及相关服务时，为了保障软件与服务的正常运行，我们会收集您的
        <span>
          硬件型号、版本分布、操作系统版本号、软件版本号、网络接入方式、功能使用频率时长、崩溃数据、安装、使用及性能数据信息。此外我们将获取您的设备ID，MAC地址、IMEI信息作为参数，通过相应算法生成代表设备唯一性的ID，作为辨别用户身份唯一性的依据；我们在上传单据等功能需要的情况下，会申请访问您设备的相机权限、照片及文件权限，方便您进行相关单据的上传或异常情况的说明；我们在您由于业务的需要，需进行更多司机用户的邀请时，会申请发送短信的权限，方便您把邀请信息快速发送给想要邀请的司机。
        </span>
        请您了解，这些信息是我们提供服务和保障产品正常运行所必须收集的基本信息。
        <p>
          补充：我们将通过【友盟+】平台提供的{【友盟+】移动统计分析服务}来合法地收集和使用您的上述相关个人设备信息，为了便于您了解【友盟+】平台的隐私政策，我们在此附上【友盟+】平台《隐私政策》（https://www.umeng.com/page/policy）。如果您不希望个人信息被我们通过【友盟+】平台处理和使用，您可以自主选择登录网址（https://outdip.umeng.com/opt_out.html）进行退出操作。
        </p>
      </div>
      <div class="secondary-title">（二） 注册、认证、登录中交智运产品</div>
      <div class="content-text">
        <p>
          1.当您注册、登录中交智运产品及相关服务时，您可以通过手机号创建账号，并将接收到我们发送的短信验证码，我们将通过该短信验证码来验证您的身份是否有效，并且您可
          <span> 完善相关的网络身份识别信息（如密码）</span>
          ，收集这些信息是为了帮助您完成注册。
        </p>
        <p>
          2.在您使用中交智运产品等需进行身份认证的功能或服务时，根据中华人民共和国相关法律法规，您可能需要提供
          <span
            >您的真实身份信息（真实姓名、身份证、电话号码、驾驶证、行驶证）</span
          >
          以完成实名验证。这些信息属于个人敏感信息，我们将采用行业内通行的方式，尽最大的商业努力来保护您个人敏感信息的安全。如果您不提供这些信息，您将可能无法获得相关服务，但不影响中交智运平台产品中其他功能与服务的正常使用。
        </p>
      </div>

      <div class="secondary-title">（三） 为您推荐定制化的信息或服务</div>
      <div class="content-text">
        定制化的服务推荐是“中交智运司机版”最基础、最核心的功能之一。为实现这一功能，我们可能会收集并使用下列信息：

        <p>
          获得您的明示同意后的定位功能并提供您的地理位置信息。我们需要
          <span> 收集您的位置信息。</span>
          我们会对中交智运用户的位置信息进行定位并帮助您获得更加精准的定位、导航服务。您可以通过系统授权关闭定位功能，停止中交智运对您的地理位置信息的收集。
        </p>
        <p>
          理位置属于个人敏感信息，拒绝提供该信息，我们将不能基于地理位置向您推送最匹配的信息，并影响中交智运产品其他功能与服务的正常使用。
        </p>
      </div>
      <div class="secondary-title">
        （四） 您使用或订购第三方产品或服务的信息
      </div>
      <div class="content-text">
        为了给您更加便捷的生活服务与更精准的制定化服务，中交智运为您接入了丰富的第三方服务，
        <span>需要获取您的软件安装列表以判断能否启用这些服务。</span>
        您可以通过“周边设施”、“我的”模块入口使用相关功能。当您使用中交智运接入的第三方服务时，可能需要提交您的
        <span>
          个人信息（部分情况下包括您的地理位置信息，车辆的位置信息、轨迹跟踪信息）。</span
        >

        您授权我们将该信息提供给为您提供服务的第三方，并授权我们间接向第三方获取相关信息，授权后产生的历史信息将在平台上长期有效。若您拒绝我们收集此类信息，我们将无法为您提供相关功能和服务，但不会影响您对业务相关核心产品和服务功能的使用。关于第三方SDK的信息，详见下方：

        <br />
        1、极光推送，收集设备识别信息，用于推送消息，官网地址： <br />
        &nbsp;&nbsp; https://www.jiguang.cn/push
        <br />
        2、高德地图，收集设备识别信息、地理位置信息、车辆信息等，用于地图位置的显示、导航，官网地址：
        <br />
        &nbsp;&nbsp;https://lbs.amap.com
        <br />
        3、微信登录、分享，收集设备识别信息，用于绑定帐号进行微信登录，官网地址：
        <br />
        &nbsp;&nbsp;https://open.weixin.qq.com
        <br />
        4、Bugly Android
        SDK，收集设备识别信息、应用列表等信息，用于错误信息上报，官网地址：
        <br />
        &nbsp;&nbsp;https://bugly.qq.com/v2/
        <br />
        5、华为推送，收集设备识别信息，用于推送消息，官网地址： <br />
        &nbsp;&nbsp;https://developer.huawei.com/consumer/cn/
      </div>

      <div class="secondary-title">
        （五） 我们可能使用您的信息用于安全防范、诈骗预防及非法监测等
      </div>
      <div class="content-text">
        为预防、发现、调查危害公共安全、侵犯个人合法权益、违反法规或协议规则的行为，用以保护您、我们或我们的关联公司、合作伙伴的合法权益及社会公益。
        例如，您在使用服务后未及时付款或完成交易，我们可能向第三方支付平台
        <span>查询您的身份信息、财产信息、联系方式，</span>
        用于调查违规订单，保障您的账户及资金安全，并及时识别诈骗和其他违法行为。
      </div>
      <div class="secondary-title">
        （六） 依法豁免征得同意收集和使用的个人信息
      </div>
      <div class="content-text">
        请您理解，在下列情形中，根据法律法规及相关国家标准，我们收集和使用您的个人信息无需征得您的授权同意：
        <p>1)与国家安全、国防安全直接相关的；</p>
        <p>2)与公共安全、公共卫生、重大公共利益直接相关的；</p>
        <p>3)与犯罪侦查、起诉、审判和判决执行等直接相关的；</p>
        <p>
          4)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；
        </p>
        <p>5)所收集的您的个人信息是您自行向社会公众公开的；</p>
        <p>
          6)从合法公开披露的信息中收集的您的个人信息的，如合法的新闻报道、政府信息公开等渠道；
        </p>
        <p>7)根据您的要求签订或履行合同所必需的；</p>
        <p>
          8)用于维护中交智运软件及相关服务的安全稳定运行所必需的，例如发现、处置中交智运软件及相关服务的故障；
        </p>
        <p>9)为合法的新闻报道所必需的；</p>
        <p>
          10)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；
        </p>
        <p>11)法律法规规定的其他情形。</p>
        特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本隐私政策处理与保护。
      </div>
      <div class="primary-title">二、我们如何存储个人信息</div>
      <div class="secondary-title">（一）信息存储的地点</div>
      <div class="content-text">
        我们依照法律法规的规定，将在境内运营过程中收集和产生的您的个人信息存储于中华人民共和国境内。目前，我们不会将上述信息传输至境外，如果我们向境外传输，我们将会遵循法律法规的规定，征求您的自主选择同意。
      </div>
      <div class="secondary-title">（二）存储期限</div>
      <div class="content-text">
        我们仅在为提供中交智运平台服务之目的所必需的期间内保留您的个人信息，超出必要期限后，我们将对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外。
      </div>

      <div class="primary-title">三、我们如何共享、转让、公开披露个人信息</div>
      <div class="secondary-title">（一）个人信息的共享、转让</div>
      <div class="content-text">
        我们不会向第三方共享、转让您的个人信息，除非经过您本人事先授权同意，或者共享、转让的个人信息是去标识化处理后的信息，且共享第三方无法重新识别此类信息的自然人主体。
        <p>1.在下列情况下，经过您的自主选择同意，我们可能会共享的个人信息</p>
        <p>（1）帮助您参加营销推广活动</p>
        <p>
          当您选择参加我们举办的有关营销活动时，根据活动需要
          <span>您提供姓名、通信地址、联系方式等活动所需信息。</span>
          经过您的明示同意，我们会将上述信息与第三方共享以便我们能委托第三方及时向您提供产品、礼品、优惠券。
        </p>
        <p>2.对共享个人信息第三方主体的谨慎评估及责任约束</p>
        <p>
          （1）经您同意，我们只会与第三方共享实现目的所必要的信息。如果第三方因业务需要，确需超出前述授权范围使用个人信息的，该第三方将需再次征求您的自主选择同意。
        </p>
        <p>
          （2）对我们与之共享您个人信息的第三方，我们会要求第三方以不低于本隐私政策所要求的保密和安全措施来处理该信息。
        </p>
      </div>
      <div class="secondary-title">（二）个⼈信息的公开披露</div>
      <div class="content-text">
        我们不会公开披露您的信息，除非遵循国家法律法规规定或者获得您的自主选择同意。我们公开披露您的个人信息会采用符合行业内标准的安全保护措施，具体如下：
        <p>
          1.对违规账号、欺诈行为进行处罚公告时，我们会披露相关
          <span>账号的必要信息。</span>
        </p>
        <p>
          2.“寻人”、“追逃”等公益项目，经根据符合法律法规的明确授权后，我们会公开披露与事件相关的信息。当事件结束后，我们将及时删除已披露的个人敏感信息。
        </p>
      </div>

      <div class="primary-title">四、您的权利</div>
      <div class="content-text">
        按照中国相关的法律、法规、标准，以及其他国家、地区的通行做法，我们保障您对自己的个人信息行使以下权利：
      </div>

      <div class="secondary-title">（一）访问您的个人信息</div>
      <div class="content-text">
        您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：
        <p>
          个人中心：如果您希望访问或编辑您的账户中的密码、手势密码信息，您可以在中交智运产品的“我的”中进行查询、访问、更正。
        </p>
        <p>订单/运单信息：您可以在中交智运产品中查询您的订单、运单记录。</p>
        <p>
          如果您无法通过上述入口访问这些个人信息，您可以随时致电客服电话
          4000888136，我们将及时解决您的问题和需求。
        </p>
      </div>
      <div class="secondary-title">（二）更正您的个人信息</div>
      <div class="content-text">
        当您发现我们处理的关于您的个人信息有错误时，您有权要求我们做出更正。您可以通过致电客服电话
        4000888136提出更正申请。
      </div>
      <div class="secondary-title">（三）删除您的个人信息</div>
      <div class="content-text">
        <p>在以下情形中，您可以向我们提出删除个人信息的请求：</p>
        <p>1、如果我们处理个人信息的行为违反法律法规；</p>
        <p>2、如果我们收集、使用您的个人信息，却未征得您的同意；</p>
        <p>3、如果我们处理个人信息的行为违反了与您的约定；</p>
        <p>4、如果您不再使用我们的产品或服务，或您注销了账号；</p>
        <p>5、如果我们不再为您提供产品或服务。</p>
        若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这些实体获得您的独立授权。
        当您从我们的服务中删除信息后，我们可能不会立即备份系统中删除相应的信息，但会在备份更新时删除这些信息。
      </div>
      <div class="secondary-title">（四）改变您授权同意的范围</div>
      <div class="content-text">
        每个业务功能需要一些基本的个人信息才能得以完成（见本策略“第一部分”)。对于额外收集的个人信息的收集和使用，您可以随时给予或收回您的授权同意。您可以通过关闭设备功能等方式改变您授权我们继续收集信息的范围或撤回您的授权：
        <br />
        当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
      </div>
      <div class="secondary-title">（五）个人信息主体注销账户</div>
      <div class="content-text">
        您随时可注销此前注册的账户，您可以通过致电客服电话
        4000888136提出注销申请。在注销账户之后，我们将停止为您提供产品或服务，并依据您的要求，删除您的个人信息或做匿名化处理，法律法规另有规定的除外。
      </div>
      <div class="secondary-title">（六）投诉举报</div>
      <div class="content-text">
        您可按照我们公示的制度进行投诉或举报。如果您认为您的个人信息权利可能受到侵害，或者发现侵害个人信息权利的线索（例如：认为我们收集您的个人信息违反法律规定或者双方约定），您可以通过拨打
        4000888136与我们联系，我们核查后会及时反馈您的投诉与举报。
      </div>
      <div class="secondary-title">（七）约束信息系统自动决策</div>
      <div class="content-text">
        在某些业务功能中，我们可能仅依据信息系统、算法等在内的非人工自动决策机制做出决定。如果这些决定显著影响您的合法权益，您有权要求我们做出解释，我们也将提供适当的挽救方式。
        <br />对于您合理的请求，我们原则上不收取费用，但对多次重复、超出合理限度的请求，我们将视情况收取一定成本费用。对于那些无端重复、需要过多技术手段（例如，需要开发新系统或从根本上改变现行惯例）、给他人合法权益带来风险或者非常不切实际（例如，涉及备份磁带上存放的信息）的请求，我们可能会予以拒绝。
        <br />在以下情形中，按照法律法规要求，我们将无法响应您的请求：
        <br />1、与国家安全、国防安全有关的；
        <br />2、与公共安全、公共卫生、重大公共利益有关的；
        <br />3、与犯罪侦查、起诉和审判等有关的；
        <br />4、有充分证据表明您存在主观恶意或滥用权利的； <br />5、
        响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。
      </div>

      <div class="primary-title">五、我们如何处理儿童的个人信息</div>
      <div class="content-text">
        我们的产品、网站和服务主要面向成人。如果没有父母或监护人的同意，儿童不得创建自己的用户账户。
        <br />对于经父母同意而收集儿童个人信息的情况，我们只会在受到法律允许、父母或监护人明确同意或者保护儿童所必要的情况下使用或公开披露此信息。
        尽管当地法律和习俗对儿童的定义不同，但我们将不满14周岁的任何人均视为儿童。
        <br />如果我们发现自己在未事先获得可证实的父母同意的情况下收集了儿童的个人信息，则会设法尽快删除相关数据。
      </div>
      <div class="primary-title">六、您的个人信息如何在全球范围转移</div>
      <div class="content-text">
        原则上，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。
        <br />
        若将来中交智运业务拓展的需要，涉及境外的情况下，中交智运将通过遍布全球的资源和服务器提供产品或服务，在获得您的授权同意后，您的个人信息可能会被转移到您使用产品或服务所在国家/地区的境外管辖区，或者受到来自这些管辖区的访问。
        <br />
        此类管辖区可能设有不同的数据保护法，甚至未设立相关法律。在此类情况下，我们会确保您的个人信息得到在中华人民共和国境内足够同等的保护。例如，我们会请求您对跨境转移个人信息的同意，或者在跨境数据转移之前实施数据去标识化等安全举措。
      </div>
      <div class="primary-title">七、本隐私权政策如何更新</div>
      <div class="content-text">
        我们可能适时会对本隐私权政策进行调整或变更，本隐私权政策的任何更新将以标注更新时间的方式公布在中交智运产品上，除法律法规或监管规定另有强制性规定外，经调整或变更的内容一经通知或公布后的7日后生效。如您在隐私权政策调整或变更后继续使用我们提供的任一服务或访问我们相关网站的，我们相信这代表您已充分阅读、理解并接受修改后的隐私权政策并受其约束。
      </div>
      <div class="primary-title">八、如何联系我们</div>
      <div class="content-text">
        如果您对本隐私政策有任何疑问、意见或建议，通过以下方式与我们联系，我们将在收到联系后的15个工作日内予以回复。
        <br />电话：4000888136
        <br />地址：天津市河西区黑牛城道13号双迎大厦20-21层，邮编300210
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Privacy",
  data() {
    return {};
  },

  components: {},

  computed: {},

  mounted() {},

  methods: {},
};
</script>
<style lang='scss' scoped>
@import '../style/common.scss';
.modify-time {
    font-size: 14px;
    line-height: 20px;

    margin-bottom: 16px;

    color: #646464;
    p {
        display: flex;

        // justify-content: flex-end;
    }
}
.primary-title {
    margin-top: 16px;
    margin-bottom: 25px;
}
.content-text {
    margin-bottom: 15px;
}
.secondary-title {
    margin-bottom: 10px;
}
// .privacy-box {
//   pad
// }

</style>